<template>
  <v-app>
    <tg-app-bar />

    <v-main>
    </v-main>
  </v-app>
</template>

<script>
import TgAppBar from './components/ui/TgAppBar.vue';

export default {
  name: 'App',

  components: {
    TgAppBar,
  },

  data: () => ({
    //
  }),
};
</script>
